export default "__VITE_ASSET__4nntBIUU__"